import Cell from '@puzzleapps/shared/src/store/models/Cell'
 
export default class CodeCrackerCell extends Cell
{
  constructor()
  {
    super()
  }

  get given() { return this._given }
  set given(given) { this._given = Boolean(Number(given)) }

  get input() { return this._input }
  set input(input) {
    if (this._isBlack) return
    this._input = input 
  }
  
  get solution() { return this._solution }
  set solution(solution) { this._solution = String(solution) }

  get isBlack() { return this._isBlack }
  set isBlack(isBlack) { this._isBlack = Boolean(isBlack) }

  get clueNumber() { return this._clueNumber }
  set clueNumber(clueNumber) { this._clueNumber = Number(clueNumber) }


  isCorrect() {
    if (this._isBlack || this._given) return true      
    else return this._input === this._solution
  }

}

